const routes = {
    HOME             : '/',
    PERMISSIONS_ADMIN: '/permissions',
    USERS            : '/users',
    DASHBOARD        : '/dashboard',
    LOGIN            : '/login',
    PROFILE          : '/profile',
    SETTINGS         : '/settings',
    PICKINGS         : '/pickings',
    ORDERS           : '/orders',
    STOCK            : '/stock',
    REPLENISHMENT    : '/replenishment',
    NEW_REPLENISH    : '/newReplenish',
    NEW_ORDER        : '/newOrder',
    NEW_DECLINATION  : '/newDeclination',
    NEW_PRODUCT      : '/newProduct',
    MESSAGES         : '/messages',
    NOTIFICATIONS    : '/notifications',
    CONTACTS         : '/contacts',
    MISSIONS         : '/missions',
    INVENTORY        : '/inventory',
    SHIPMENT         : '/shipment',  
    PACKINGS         : '/packings',
    LOCATIONS        : '/locations',
    SHOP             : '/shop',
};
  
  
export default routes;
  